export const ROUTE_DASHBOARD = "/communicative-english/dashboard";
export const ROUTE_VOCABULARY = "/communicative-english/vocabulary";
export const ROUTE_GRAMMAR = "/communicative-english/grammar";
export const ROUTE_CONVERSATION =
  "/communicative-english/conversation-practice";
export const ROUTE_READING = "/communicative-english/reading-practice";
export const ROUTE_WRITING = "/communicative-english/writing-practice";
export const ROUTE_SPOKEN = "/communicative-english/spoken-practice";
export const ROUTE_EXAMS = "/communicative-english/competitive-exams";
export const ROUTE_PROFILE = "/communicative-english/profile"

